import * as React from 'react';
import { IframeInterop } from './showExternalUrlDialog.IframeInterop';
import { ExternalActionFlow } from './ExternalActionFlow';
import { Modal } from 'core/ui-next/modal';
import { ActionButtonDefinition, PosStatelessScreenClassComponent, ScreenSize } from 'pos/ui';

type DialogParams = {
	title: string;
	iconSrc: string;
	url: string;
};

type Props = DialogParams & Modal.Actions<ExternalActionFlow>

class ExternalUrlDialog extends PosStatelessScreenClassComponent<Props> {

	private bridge: IframeInterop;

	constructor(props: Props) {
		super(props);

		const allowedOrigin = new URL(this.props.url).origin;

		this.bridge = new IframeInterop(
			allowedOrigin,
			this.close
		);
	}

	onComponentDidMount(): void {
		this.bridge.start();
	}

	onComponentWillUnmount(): void {
		this.bridge.stop();
	}

	protected getSize(): ScreenSize {
		return { width: 1000, height: 700 };
	}

	protected getScreenId(): string {
		return 'EXTERNAL_URL';
	}

	protected getTitle(): string {
		return this.props.title;
	}

	protected getImage() {
		return this.props.iconSrc;
	}

	protected useKeypad() {
		return false;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(),
			null,
			null,
			null,
			null,
			null
		];
	}

	protected getContent(): React.ReactNode {
		return <div style={{ overflow: 'hidden', height: '100%' }}>
			<iframe src={this.props.url} style={{ width: '100%', height: '100%', border: 0 }} />
		</div>;
	}
}

export async function showExternalUrlDialog(props: DialogParams): Promise<Result<ExternalActionFlow>> {
	return await Modal.show(ExternalUrlDialog, { ...props });
}